import { getValidToken } from '../utils/tokenUtils';

const BASE = '/api/admin/contracts';

export const fetchAdminContracts = async () => {
  const token = await getValidToken();
  const res = await fetch(BASE, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Kunde inte hämta kontrakt: ${res.status}`);
  return res.json();
};

export const createContract = async (payload) => {
  const token = await getValidToken();
  const res = await fetch(BASE, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Kunde inte skapa kontrakt: ${res.status}`);
  return res.json();
};

export const updateContract = async (contractId, payload) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/${contractId}`, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Kunde inte uppdatera kontrakt: ${res.status}`);
  return res.json();
};

export const deleteContract = async (contractId) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/${contractId}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `Kunde inte ta bort kontrakt: ${res.status}`);
  }
};

export const uploadContractResource = async (contractId, file) => {
  const token = await getValidToken();
  const formData = new FormData();
  formData.append('file', file);
  const res = await fetch(`${BASE}/${contractId}/resources`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });
  if (!res.ok) throw new Error(`Kunde inte ladda upp fil: ${res.status}`);
  return res.text(); // returns the saved file name
};

export const deleteContractResource = async (contractId, fileName) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/${contractId}/resources/${encodeURIComponent(fileName)}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Kunde inte ta bort resurs: ${res.status}`);
};

export const downloadContractResource = async (contractId, fileName) => {
  const token = await getValidToken();
  const res = await fetch(`${BASE}/${contractId}/resources/${encodeURIComponent(fileName)}/download`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Kunde inte ladda ner fil: ${res.status}`);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
